import { PageHeader } from "@idwal/idwal-react-components"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { pathMapper } from "../../utils/pathMapper"
import "./PageHeaderWrapper.css"
import { formatDefectId } from "@idwal/idwal-utilities/lib/helpers"
import { useAppSelector } from "../../hooks/storeHooks"
import { selectRectification } from "../../store/selectors/rectificationSelector"
import { Capability } from "../../types/Capability"
import { useCapabilities } from "../../hooks/useCapabilities"
import { ListPicker } from "../ListPicker/ListPicker"
import {selectHasFleetAccess} from "../../store/selectors/userSelectors";
import { useMemo } from "react"
import { displayByCapabilities } from "../../utils/UserHelper"

export const PageHeaderWrapper = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const hasFleetAccess = useAppSelector(selectHasFleetAccess);

    const { capabilities } = useCapabilities([
        Capability.CAP_FLEETAPP_VIEW_DEFECTS,
        Capability.CAP_FLEETAPP_VIEW_FLEETS,
        Capability.CAP_FLEETAPP_VIEW_GRADES,
        Capability.CAP_FLEETAPP_VIEW_SUBGRADES,
        Capability.CAP_FLEETAPP_VIEW_RECTIFICATIONS,
        Capability.CAP_FLEETAPP_VIEW_PSC,
        Capability.CAP_FLEETAPP_DASHBOARD
    ]);

    const displayByCapability = useMemo(
        () => displayByCapabilities(capabilities, pathname),
        [capabilities, pathname]
    );

    let currentPage = pathname.split("/").pop() ?? "";
    currentPage = currentPage === "" ? t("pageHeader.homePage") : currentPage;

    if (!hasFleetAccess) {
        currentPage = "";
    }

    const rightHandElements = [
        hasFleetAccess && displayByCapability ? <ListPicker key="list-picker" /> : <></>,
    ]

    const pathCrumbs = [...pathname.split("/").slice(1, -1)];

    let mappedCurrentPage = pathMapper(currentPage, t) ?? "";
    let mappedPaths = pathCrumbs.map((path) => pathMapper(path, t)) as string[];

    const { defect } = useAppSelector(selectRectification);

    if (currentPage === t("pageHeader.rectifications").toLowerCase()) {
        mappedPaths = defect?.defectId ? [`${t("pageHeader.defects")}`] : [];
        mappedCurrentPage = defect?.defectId ? `${formatDefectId(defect.defectId)}` : '';
    }

    return (
        <PageHeader 
            currentPageCrumb={mappedCurrentPage} 
            pathCrumbs={mappedPaths} 
            rhsInteractiveElements={rightHandElements}
            lhsInteractiveElements={[]}
            trial={capabilities.CAP_FLEETAPP_VIEW_PSC}
        />
    )
}
